module.exports = __webpack_public_path__ + "static/wedding-4-8d42a356d4d426e50dbc4285a73f548a.gif";